<template src="./Icon.html"></template>
<style lang="scss" src="./Icon.scss"></style>

<script>
	/**
	 * An icon set used by the page.
	 * @vue-prop {string} type The icon type
	 * @vue-prop {string} [brand] brand for differentiation
	 * @fire {MouseEvent Icon#click}
	 */
	export default {
		data () {
			return {
				brand: ''
			};
		},
		props: {
			type: {
				type: String
			}
		},
		mounted () {
			this.brand = process.env.VUE_APP_BRAND;
		}
	};
</script>
